import React, { useEffect } from "react";
import { Container, Card, Button } from "react-bootstrap";
import { useNavigate, useParams } from "react-router-dom";
import { Utils } from "../../common/Utils";
import { DeleteCookie } from "../../common/CookieHelper";
import { useGlobal } from "../../contexts/GlobalContext";
import { CartGateway } from "../../gateways/CartGateway";
import { GetCartCookieKey } from "../../gateways/SiteGateway";
import { SiteCookie } from "../../model/SiteModel";

const OrderSuccess: React.FC = () => {
  const navigate = useNavigate();
  const { orderNumber } = useParams(); // Get the order ID from URL
  const { user, updateCart } = useGlobal();

  useEffect(() => {
    const clearCart = async () => {
      DeleteCookie(GetCartCookieKey);
      DeleteCookie(SiteCookie.SnapScanRedirect);
      
      if (user) {
        await CartGateway.DeleteCart(user);
      }
      updateCart();
    };
    clearCart();
  }, [user, updateCart]);

  return (
    <Container className="main-container d-flex justify-content-center align-items-center vh-100">
      <Card className="text-center p-4 shadow-sm">
        <Card.Body>
          <h2 className="text-success">🎉 Order Successfully Placed!</h2>
          <p><b>{`Order Number: ${orderNumber}`}</b></p>
          <p>Thank you for your order. Your order is being processed.</p>
          <p>We’ll notify you on the progress shortly.</p>

          <Button variant="primary" className="mt-3" onClick={() => navigate(Utils.GetUrl("/products"))}>
            Go Back to Home
          </Button>
        </Card.Body>
      </Card>
    </Container>
  );
};

export default OrderSuccess;